import { Link, isRouteErrorResponse, useRouteError } from 'react-router';
import { ErrorState } from '@/components/common';
import { ROUTES } from '@/constants';
import { Button } from '@/shared/ui/button';

/**
 * What renders when a route fails to load or a path does not exist.
 *
 * A 404 is a different message from a crash: one is a wrong address, the other
 * is our fault, and telling them apart is the difference between a useful page
 * and a shrug. The display itself is ErrorState, shared with ErrorBoundary.
 */
export function RouteError() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  return (
    <ErrorState
      full
      code={isRouteErrorResponse(error) ? error.status : 'Error'}
      title={notFound ? 'That page does not exist' : 'Something went wrong'}
      description={
        notFound
          ? 'Check the address, or head back to your dashboard.'
          : 'The page could not be loaded. Try again, or contact support if it continues.'
      }
      action={
        <Button asChild>
          <Link to={ROUTES.dashboard}>Back to dashboard</Link>
        </Button>
      }
    />
  );
}
